import React, { useCallback, useMemo, useState } from 'react';
import { Label, LabelGroup, Button } from '@patternfly/react-core';
import _ from 'lodash';

import { useTranslation } from 'localization/useTranslation';
import EditItemModal from 'components/Modals/EditItemModal';
import ModelType from 'components/Model/ModelType';


/**
 *
 * @param {*} tagFilterList - tagFilter in query format ["tag1=value1", "tag2=value2"]
 */
export const parseTagsFilterListToTagObjects = (tagFilterList) => {
  return _.map(tagFilterList, (tag, index) => {
    const [, name, value] = tag.match(/(.+?)=(.*)/);
    return { name, id: index, value };
  });

};

export const createTagsFilterListFromTags = (tags) => {
  return _.map(tags, (tag) => `${tag.name}=${tag.value}`);
};


export const toTagObjects = (tags) => {
  let index = 0;
  let tagArray = [];
  _.each(tags, (values, tag) => {
    const val = _.map(values, value => {
      return {
        name: tag,
        value: value,
        id: index++
      };
    });
    tagArray.push(val);
  });
  return _.flatten(tagArray);
};


const Tags = ({ tags, setTags }) => {
  const T = useTranslation();
  const [tag, setTag] = useState(null);

  const tagModel = useMemo(() => {
    return [
      {
        type: ModelType.TEXT,
        path: 'name',
        label: T.tag.name,
        placeholder: T.tag.name_placeholder
      },
      {
        type: ModelType.TEXT,
        path: 'value',
        label: T.tag.value,
        placeholder: T.tag.value_placeholder
      }
    ];
  }, [T.tag.name, T.tag.name_placeholder, T.tag.value, T.tag.value_placeholder]);

  const onRemoveTag = (tagId) => {
    setTags(oldTags => oldTags.filter((t) => t.id !== tagId));
  };

  const updateTags = useCallback((tag, index) => {
    setTags(oldTags => {
      oldTags[index] = {
        name: tag.name,
        id: tag.id,
        value: tag.value
      };
      return oldTags;
    });
  }, [setTags]);


  const onAddTag = useCallback(() => {
    setTag({
      name: '',
      value: '',
      id: _.max(_.map(tags, tag => tag.id)) + 1,
      index: _.size(tags)
    });
  }, [tags]);


  const onEditTag = useCallback((tag, index) => {
    setTag({ ...tag, index });
  }, []);

  const onSaveTag = useCallback((tag) => {
    updateTags(tag, tag.index);
    setTag(null);
  }, [updateTags]);


  return (
    <React.Fragment>
      <LabelGroup categoryName={T.tags.category}
        numLabels={5}
        addLabelControl={
          <Label color="blue" variant="outline" isOverflowLabel onClick={onAddTag}>
            { T.tags.add }
          </Label>
        }
      >
        { _.map(tags, (tag, index) => {
          return (
            <Label
              key={tag.id}
              id={tag.id}
              variant="filled"
              color="green"
              onClose={() => onRemoveTag(tag.id)}
              {...tag.props}
            >
              <Button
                variant="plain"
                onClick={() => onEditTag(tag, index)}
              >
                <b>{ tag.name }</b> : <i>{ tag.value }</i>
              </Button>
            </Label>
          );
        }) }
      </LabelGroup>
      <EditItemModal
        title={T.tag.edit}
        isOpen={tag != null}
        models={tagModel}
        item={tag}
        setItem={setTag}
        onSave={onSaveTag}
        saveText={T.common.save}
        onCancel={() => setTag(null)} />
    </React.Fragment>
  );
};


export default Tags;
